import React, { useState, useEffect } from 'react';
import Rating from 'rating-react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const NewIndividualCommentComponent = (props) => {
  const { name, lastname, main_image, stars, detail, extraClass, lenguage } = props;
  const [translatedText, setTranslatedText] = useState('');

  useEffect(() => {
    fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=es&tl=en&dt=t&q=${encodeURIComponent(
        detail,
      )}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const translation = data[0]?.map((part) => part[0]).join('');
        setTranslatedText(translation);
      })
      .catch((err) => {
        console.error('Error al traducir', err);
      });
  }, []);

  let profileImage = '';
  try {
    const parsed = JSON.parse(main_image);
    if (Array.isArray(parsed) && parsed.length > 0) {
      profileImage = parsed[0];
    }
  } catch (err) {
    profileImage = main_image;
  }
  return (
    <FlexContainer className={'flex-column padtb20 ' + extraClass}>
      <FlexContainer className={'gap-16'}>
        {profileImage && (
          <img
            src={profileImage}
            alt={`${name} ${lastname}`}
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              objectFit: 'cover',
              marginTop: '4px',
            }}
          />
        )}

        <FlexContainer className={'flex-column gap-4'}>
          <FlexContainer
            className={'gap-8 text-16 m-text-12 align-center fontPink1 align-items-center'}
          >
            <Rating
              value={stars}
              size={'sm'}
              activeColor="#F985C4"
              color="#F985C4"
              disabled
              disabledOpacity={true}
            />
          </FlexContainer>
          <FlexContainer className={'gap-8 text-12 m-text-10 align-center'}>
            <strong className="text-14 m-text-12">{`${name} ${lastname || ''}`} </strong>
            {lenguage === 'ES' ? ' | 14 de marzo 2025' : ' | March 14, 2025'}
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      {detail && (
        <FlexContainer className={'text-14 margt6'}>
          {lenguage === 'ES' ? detail : translatedText}
        </FlexContainer>
      )}
      {!detail && <FlexContainer className={'text-14 margt6'}>{'Sin comentarios'}</FlexContainer>}
    </FlexContainer>
  );
};

const CommmentComponent = (props) => {
  const { spaceComment, lenguage, extraClass } = props;
  return (
    <FlexContainer
      className={
        'flex-column width100 border2pxPurple8 border-rad8px grayShadowBottom ' + extraClass
      }
    >
      <FlexContainer
        className={'bgPurple8 text-18 padlr10 padtb10 align-items-center justify-between'}
      >
        <strong>
          {(lenguage === 'EN' ? 'Reviews ' : 'Opiniones ') + '(' + spaceComment?.length + ')'}
        </strong>
        <FlexContainer className={'border3pxGray7 border-rad4px text-18 padtb4 padlr4'}>
          <strong>5.0</strong>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className={'flex-column padlr10 m-padlr10 bgWhite border-rad8px'}>
        {spaceComment?.length > 0 ? (
          spaceComment.map((comment, index) => (
            <NewIndividualCommentComponent
              key={index}
              lenguage={lenguage}
              name={comment.user_name}
              stars={comment.comment_stars}
              main_image={comment.main_image}
              lastname={comment.user_lastname}
              detail={comment.comment_detail}
              extraClass={index + 1 < spaceComment?.length ? 'borderPurpleBottom' : ''}
            />
          ))
        ) : (
          <Label className="text-16 width100 margtb20 text-justify">
            {lenguage === 'EN' ? 'No comments yet' : 'Aún no hay comentarios'}
          </Label>
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

export default CommmentComponent;
